import { capitalize } from 'vue';

import i18n from '@/vueI18n';

const type = 'UnitTag';

export interface IUnitTagApi {
  id: number;
  tag: string;
  description: string;
  exclude_by_default: boolean;
}

export default class UnitTag {
  id: number;

  tag: string;

  name: string;

  description: string;

  excludedByDefault: boolean;

  type: string;

  constructor(id = -1, tag: string, name: string, description: string, excludedByDefault: boolean) {
    this.type = type;
    this.id = id;
    this.tag = tag;
    this.name = name;
    this.description = description;
    this.excludedByDefault = excludedByDefault;
  }

  static fromApi(apiObject: IUnitTagApi, id: number): UnitTag {
    const name = capitalize(i18n.global.t(`options.tags.names.${apiObject.tag}`));
    const description = capitalize(i18n.global.t(`options.tags.description.${apiObject.tag}`));

    return new UnitTag(id, apiObject.tag, name, description, apiObject.exclude_by_default ?? false);
  }
}
